import { useWebMCP } from "../../hooks/useWebMCP";

// Rejestruje narzędzia WebMCP (jeśli przeglądarka wspiera). Nic nie renderuje.
const WebMcp = () => {
  useWebMCP();
  return null;
};

export default WebMcp;
